var React = require('react');

function CheckOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z"}));
}

CheckOutline.defaultProps = {"style":{"width":"24px","height":"24px"},"viewBox":"0 0 24 24"};

module.exports = CheckOutline;

CheckOutline.default = CheckOutline;
